import axios from "axios";
import { URLs } from "./configuration";
import { getUrlParam } from "../../utils/urlParams";
const apiUrl =
  "https://amplifai-reactjs-webapi.azurewebsites.net/api/" ||
  process.env.REACT_APP_API_URL;
axios.defaults.baseURL = apiUrl;
const urlCompanyGuid = getUrlParam("companyguid");
const defaultParam = {
  companyguid: urlCompanyGuid || sessionStorage.getItem("currentCompany"),
};

const createApiMethod = (url) => (param) =>
  axios.get(url, { params: { ...defaultParam, ...param } });

const APIs = Object.keys(URLs).reduce((acc, key) => {
  acc[key] = createApiMethod(URLs[key]);
  return acc;
}, {});

export default APIs;
